class Utils {
    getLocale () {
        return navigator.language || navigator.browserLanguage || (navigator.languages || ['es-AR'])[0];
    }

    getToken () {
        return localStorage.getItem('token');
    }

    // getToday () {
    //     return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
    // }

    // isTodayBetween (since, until) {
    //     if (until != null) {
    //         return ((this.getToday() >= new Date(since).toISOString().slice(0, 10)) && (this.getToday() <= new Date(until).toISOString().slice(0, 10)));
    //     } else {
    //         return (this.getToday() >= new Date(since).toISOString().slice(0, 10));
    //     }
    // }
    getToday () {
        return new Date().toISOString().slice(0, 10);
    }

    isTodayBetween (since, until) {
        const today = new Date();
        const sinceDate = new Date(since);

        if (until) {
            const untilDate = new Date(until);
            return (today >= sinceDate) && (today <= untilDate);
        } else {
            return today >= sinceDate;
        }
    }

    isDateLessThanToday (date) {
        // return (this.getToday() >= new Date(date).toISOString().slice(0, 10));
        return (new Date(date).getFullYear() <= 2020);
    }

    getDateToPicker (date) {
        return new Date(date).toISOString().slice(0, 10);
    }

    getTodayString (separator = '/') {
        const [year, month, day] = this.getToday().split('-');
        return `${day}${separator}${month}${separator}${year}`;
    }

    formatDate (date) {
        const options = { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, year: 'numeric', month: '2-digit', day: '2-digit' };
        const formatter = new Intl.DateTimeFormat('es-AR', options);
        const [day, month, year] = formatter.format(new Date(date)).split('/');
        return `${day}/${month}/${year}`;
    }

    formatDateTime (date) {
        const options = { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
        const formatter = new Intl.DateTimeFormat('es-AR', options);
        const [day, month, year] = formatter.format(new Date(date)).split('/');
        const time = new Date(date).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        return `${day}/${month}/${year} ${time}`;
    }

    getTodayISOString () {
        return new Date(this.getToday()).toISOString();
    }

    getQueryDate (filters) {
        if (!filters || !Object.keys(filters).length) return '';

        let query = '';
        if (filters.startDate) {
            query += `start_date=${filters.startDate.toISOString()}`;
        }
        if (filters.endDate) {
            query += `&end_date=${filters.endDate.toISOString()}`;
        }
        return query;
    }

    getQueryPage (filters, otherFilters) {
        if (!filters || !Object.keys(filters).length) return '';

        let query = '';
        if ('pagination' in filters) {
            if (filters.pagination.page) {
                query += `page=${filters.pagination.page}`;
            }
            if (filters.pagination.size) {
                query += `&size=${filters.pagination.size}`;
            }
        }
        if (!query) {
            return query;
        }

        return otherFilters.length ? `&${query}` : query;
    }

    getQueryTypes (filters) {
        if (!filters || !filters?.length || filters.join('') === '') return '';
        return `&types=${filters.join(',')}`;
    }

    getQueryProducts (filters) {
        if (!filters || !filters?.length) return '';
        return `&products=${filters.join(',')}`;
    }

    getQueryConfig (filters) {
        if (!filters) return '';
        let query = '';
        if (filters.config) {
            query += `&config=${filters.config}`;
        }
        return query;
    }

    getQueryTrackIds (filters) {
        if (!filters || !filters?.length) return '';
        return `&track_id=${filters.join(',')}`;
    }

    saveFile (data, fileName) {
        // create file link in browser's memory
        const href = URL.createObjectURL(data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', fileName); // or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }

    isDigit (e) {
        let charCode = e.charCode;
        if (!(charCode >= 48 && charCode <= 57) || (!/^[0-9]+$/.test(charCode))) {
            e.preventDefault();
        }
    }

    base64ToFile (base64, fileType = 'kmz') {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: fileType });
        return URL.createObjectURL(blob);
    }
}

export default new Utils();
